// extracted by mini-css-extract-plugin
export default {"SiderMenu":"HelpPages_SiderMenu__R-qHx","footer":"HelpPages_footer__BTyfk","selectedTitle":"HelpPages_selectedTitle__6kjeo"};